@import 'igws-accordion.less';

.accordion--plus,
.accordion--arrow {
  &::after {
    content: '';
    left: 0;
  }
}
@media (max-width: @medium-breakpoint) {
  .accordion--plus,
  .accordion--arrow {
    &::after {
      left: 10px;
    }
  }
}
